module.exports = __webpack_public_path__ + "img/contacts.0227512d.svg";